import firebase from "firebase/app";
// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import axios from "axios";
import config from "./../helpers/Constants";

class FirebaseAuthBackend {
  constructor(firebaseConfig) {
    if (firebaseConfig) {
      // Initialize Firebase
      firebase.initializeApp(firebaseConfig);
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          localStorage.setItem("authUser", JSON.stringify(user));
        }
        // else {
        //   sessionStorage.removeItem("authUser");
        // }
      });
    }
  }

  /**
   * Registers the user with given details
   */
  registerUser = (users) => {
    let decodedString = localStorage.getItem("authUser");
    let authUser = JSON.parse(atob(decodedString));
    var user_name = authUser.username;
    var user_lang = authUser.language;
    const options = {
      headers: {
        Nexion_API_Key: config.API_KEY,
        logged_user: user_name,
      },
    };
    //console.log(user);
    return new Promise((resolve, reject) => {
      axios.post(config.API + "add_user?company=Nexion", users, options).then(
        (user) => {
          //console.log(user);
          if (user.data.status === "success") {
            alert("User Added Successfully");
            window.location.reload(false);
          } else if (user.data.status === "failed") {
            alert("Username is Already Exists!!");
          } else {
            alert("There is some problem while adding user");
          }
        },
        (error) => {
          reject(this._handleError(error));
        }
      );
    });
  };

  editUser = (users) => {
    //console.log(user);
    const options = {
      headers: {
        Nexion_API_Key: config.API_KEY,
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .post(config.API + "update_user?company=Nexion", users, options)
        .then(
          (user) => {
            console.log(users);
            if (user.data.status === "success") {
              alert("User Updated Successfully");
              // window.location.reload(false);
            } else if (user.data.status === "failed") {
              alert("There is some problem while updating user");
            } else {
              alert("There is some problem while updating user");
            }
          },
          (error) => {
            reject(this._handleError(error));
          }
        );
    });
  };

  /**
   * Login user with given details
   */
  loginUser = (email, password) => {
    const options = {
      headers: {
        Nexion_API_Key: config.API_KEY,
      },
    };

    return new Promise((resolve, reject) => {
      let request = {
        username: email,
        password: password,
      };
      const d = new Date();
      let year = d.getFullYear();
      axios.post(config.API + "login?company=Nexion", request, options).then(
        (user) => {
          if (user.data) {
            var encodedUser = btoa(JSON.stringify(user.data));
            // var decodedString = JSON.parse(atob(encodedString));
            // console.log(encodedUser);
            let ling_array = user.data.ling.split(",");
            let ling_string = ling_array
              .map((e) => JSON.stringify(e))
              .join(",");
            localStorage.setItem("authUser", encodedUser);
            localStorage.setItem("lang", "it");
            localStorage.setItem("ver_bar", "vehicle_database");
            localStorage.setItem("diag_bar", "days");
            localStorage.setItem("map_display", "no");
            localStorage.setItem("data_visible_days", "14"); // As there is limited data right now so after release it will be 14
            localStorage.setItem("diagnosis_custom_month_year", year);
            localStorage.setItem("user_db_lang", ling_string);
            localStorage.setItem("data_source", "production");
            resolve(true);
          } else {
            //console.log("user not found");
            alert("Invalid Login Credentials!!");
            resolve(true);
          }
        },
        (error) => {
          reject(this._handleError(error));
        }
      );
    });
  };

  /**
   * forget Password user with given details
   */
  forgetPassword = (email) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .sendPasswordResetEmail(email, {
          url:
            window.location.protocol + "//" + window.location.host + "/login",
        })
        .then(() => {
          console.log("yes authutils");
          resolve(true);
        })
        .catch((error) => {
          reject(this._handleError(error));
        });
    });
  };

  /**
   * Logout the user
   */
  logout = () => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          resolve(true);
          localStorage.removeItem("authUser");
        })
        .catch((error) => {
          reject(this._handleError(error));
        });
    });
  };

  setLoggeedInUser = (user) => {
    localStorage.setItem("authUser", JSON.stringify(user));
  };

  /**
   * Returns the authenticated user
   */
  getAuthenticatedUser = () => {
    // var encodedUser = btoa(JSON.stringify(user.data));
    // var decodedString = JSON.parse(atob(encodedString));
    if (!localStorage.getItem("authUser")) return null;
    return JSON.parse(atob(localStorage.getItem("authUser")));
  };

  /**
   * Handle the error
   * @param {*} error
   */
  _handleError(error) {
    // var errorCode = error.code;
    var errorMessage = error.message;
    return errorMessage;
  }
}

let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config
 */
const initFirebaseBackend = (config) => {
  if (!_fireBaseBackend) {
    _fireBaseBackend = new FirebaseAuthBackend(config);
  }
  return _fireBaseBackend;
};

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
  return _fireBaseBackend;
};

export { initFirebaseBackend, getFirebaseBackend };
